import { useEffect } from 'react'
import { Container, Typography } from '@material-ui/core'
import IllustratedSteps from 'baby-ui/compounds/IllustratedSteps'
import { observer } from 'mobx-react-lite'
import useStyles from './styles'
import HeroCTAWidget from '../../widgets/HeroCTAWidget'
import { useDMEStore } from '../../store'
import {
  THREE_STEPS_PARACHUTE_URL_IMG_URL,
  THREE_STEPS_PORTRAIT_URL_IMG_URL,
  THREE_STEPS_PUMP_IMG_URL,
} from '../constants'
import { HOME_PATH } from '../../constants'
import GuidesWidget from '../../widgets/GuidesWidget'
import { Guide, UI } from '../../../global'
import { globalStyles } from '../../styles'
import { useLayout } from '../../widgets/Layout'
import { configureView } from '../../utils/ViewConfiguration'
import PLPView from '../PLPView'
import * as productFilterSearchParams from '../../utils/productFilterSearchParams'

export interface HomeViewProps extends UI.LifeCycle {
  guides: Guide[]
}

const HomeView: UI.ViewComponent<HomeViewProps> = observer(
  ({ guides, onComponentDidMount }) => {
    const classes = useStyles()
    const globalCSS = globalStyles()
    const store = useDMEStore()
    const layout = useLayout()

    useEffect(() => {
      onComponentDidMount()
    }, [])

    return (
      <div className={classes.homeViewWrapper}>
        {!layout?.isFreeGiftEnabled && (
          <div className={globalCSS.babylistHealthStripe} />
        )}
        <HeroCTAWidget
          onViewOptions={({ insuranceState, insuranceProvider }) => {
            store.insurance.set({
              ...insuranceProvider,
              state: insuranceState,
            })
            store.saveSnapshotToLocalStorage()
            const { search } = window.location
            if (productFilterSearchParams.parse(search)) {
              PLPView.navigate({ search })
            } else {
              PLPView.navigate()
            }
          }}
        />

        <Container className={classes.illustratedStepsWrapper}>
          <IllustratedSteps
            steps={[
              {
                content: 'Provide some insurance info & select your pump',
                imageUrl: THREE_STEPS_PUMP_IMG_URL,
                alt: 'Breast pump',
              },
              {
                content:
                  "We'll verify your coverage and handle all the paperwork",
                imageUrl: THREE_STEPS_PORTRAIT_URL_IMG_URL,
                alt: 'Prescription',
              },
              {
                content: 'Sit back and wait for your pump to arrive',
                imageUrl: THREE_STEPS_PARACHUTE_URL_IMG_URL,
                alt: 'Product delivery',
              },
            ]}
            subtitle="in 3 easy steps!"
            title="Get Your Breast Pump"
          />
        </Container>

        {guides.length > 0 && (
          <Container className={classes.guideSection}>
            <Typography
              className={classes.heroText}
              color="primary"
              component="h2"
              variant="h5"
            >
              <b>Breast Pump Guides</b>
            </Typography>

            <GuidesWidget openGuidesInNewTab guides={guides} />
          </Container>
        )}
      </div>
    )
  }
)

export default configureView(HomeView)({ pathname: HOME_PATH })
